import { render, staticRenderFns } from "./PieChartVendas.vue?vue&type=template&id=9534c0fa&"
import script from "./PieChartVendas.vue?vue&type=script&lang=js&"
export * from "./PieChartVendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports